// @flow
/* Styles for common components */

import { orange, cream, error, black, white, primary } from './colors'
import mixins from './mixins'

// Constants
export const INDENT = 15

// Info
export const warning = {
  fontSize: '0.9em',
  fontWeight: 400,
  lineHeight: '1.4em',
  textAlign: 'justify',
  color: error(),
  border: `1px solid ${orange()}`,
  borderRadius: 5,
  background: cream(),
}
export const message = {
  paddingLeft: INDENT,
  marginBottom: INDENT,
  fontSize: '.875rem',
  textAlign: 'justify',
  borderLeft: `2px solid ${primary()}`,
}

export const attentionMessage = {
  ...message,
  borderLeft: `2px solid ${orange()}`,
}

// Sidebar
export const sidebar = {
  container: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    width: 300,
    padding: INDENT,
    overflow: 'scroll',
    background: white(),
    color: black(0.87),
    boxShadow: `-2px 0 2px ${black(0.2)}`,
  },
  form: {
    fontSize: '.875rem',
    lineHeight: '1.25rem',
  },
  h3: {
    fontSize: '1.1em',
    fontWeight: '400',
    lineHeight: '1.4em',
    letterSpacing: '-.5px',
    margin: '.5em 0 1.34em',
  },
  buttonWrapper: {
    ...mixins.flex('flex-end'),
  },
  button: {
    marginRight: INDENT,
    color: white(),
  },
}

export default {
  INDENT,
  warning,
  message,
  sidebar,
  attentionMessage,
}
